import * as React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import ConfigurationTable from "./license-configuration/bms/BmsConfigurationTable";
import ConfigurationView from "./license-configuration/bms/BmsConfigurationView";
import ApplicationLayout from "components/layout/ApplicationLayout";
import { VideoTutorialButton } from "components/modal/video-modal/video-tutorial-button/VideoTutorialButton";
import { VideoModal } from "components/modal/video-modal/VideoModal";
import { LICENSES_ROUTE } from "components/router/Routes";
import { TutorialVideoLink } from "domain/tutorialVideos";

export default function BmsConfigurationView(): JSX.Element {
    const { t } = useTranslation();
    const [state, setState] = useState({ count: 0 });
    const [showVideoModal, setShowVideoModal] = React.useState(false);
    const watchTutorialButton = <VideoTutorialButton onClick={() => setShowVideoModal(true)} />;

    function onConfigurationAdded() {
        return setState((prevState) => ({ count: prevState.count + 1 }));
    }

    return (
        <>
            <ApplicationLayout
                viewTitle={t("Configuration.title")}
                view={<ConfigurationTable initialConfiguration={[]} count={state.count} />}
                mainRoute={LICENSES_ROUTE}
                viewActions={
                    <>
                        {watchTutorialButton}
                        <ConfigurationView onConfigurationAdded={onConfigurationAdded} />
                    </>
                }
                hideActions={watchTutorialButton}
            />
            <VideoModal
                isOpen={showVideoModal}
                hideModal={() => setShowVideoModal(false)}
                linkUrl={TutorialVideoLink.BMS_CONFIG}
            />
        </>
    );
}
